<template>
  <div>
    <ProjectHeader :project="project" :userInfo="userInfo"/>
    <br>
    <ProjectConceptGeneral :project="project"/>
    <br>
    <ProjectObservations :project="project" v-if="project.overall_final == 0"/>
    <br>
    <ProjectRestrictions :project="project" v-if="project.observation_restrictions.length > 0"/>
    <br>
    <vx-card>
        <vs-button
          v-if="project.project_type_name === 'Prueba de poligrafía' && isPolygraphFileUrl(project.polygraph_attachment)"
          type="gradient"
          style="background: #640064;"
          @click="openPolygraphAttachment()"
          target="_blank"
        >
          Descargar reporte de poligrafía
        </vs-button>
        <vs-button
          v-else-if="project.project_type_name === 'Prueba de poligrafía'"
          type="gradient"
          style="background: #640064;"
          :href="{ url: '/project' }"
        >
          Ver resultado
        </vs-button>
        <vs-button
          v-if="project.project_type_name !== 'Prueba de poligrafía'"
          type="gradient"
          style="background: #640064;"
          :href="{ url: '/project' }"
        >
          Ver resultado
        </vs-button>
    </vx-card>
  </div>
</template>

<script>
import ProjectHeader from './ProjectHeader.vue'
import ProjectConceptGeneral from './ProjectConceptGeneral.vue'
import ProjectDataForm from './ProjectDataForm.vue'
import ProjectObservations from './ProjectObservations.vue'
import ProjectCreditValidation from './ProjectCreditValidation.vue'
import ProjectJudicialVerification from './ProjectJudicialVerification.vue'
import ProjectAnalyst from './ProjectAnalyst'
import ProjectRestrictions from './ProjectRestrictions.vue'
import api from '../../mixins/api.js'
import secureFiles from '../../mixins/secureFiles.js'
import { isPolygraphFileUrl } from '@/utils/secureFileUrl'
export default {
  mixins: [api, secureFiles],
  props: {
    popupShowActive: Boolean,
    project: Object,
    userInfo:Object
  },
  data (){
    return{
      colorx:"rgba(255,255,255,255)"
    }
  },
  methods: {
    isPolygraphFileUrl,
    goToProject(){
      this.$router.push('project')
    },
    openPolygraphAttachment () {
      this.openSecureFileUrl(this.project.polygraph_attachment, {
        resourceType: 'project_attachment',
        id: this.project.id,
        attachment: 'polygraph_attachment'
      })
    }
  },
  created(){

  },
  mounted(){
  },
  components:{
    ProjectHeader,
    ProjectConceptGeneral,
    ProjectDataForm,
    ProjectObservations,
    ProjectCreditValidation,
    ProjectJudicialVerification,
    ProjectAnalyst,
    ProjectRestrictions
  },
  computed:{

  }

}
</script>

<style>
  .vs-popup{
    width: 80% !important;
  }
  .button-report{
    margin-right: 1rem !important;
  }
</style>
